import request, { decodedData } from './request';

/**
 * Get Basic plan monthly price based on user region
 */
async function getBasicPlanPrice() {
  try {
    console.log('Getting Basic plan price for user region...');
    
    // Get user region from localStorage
    const userRegionData = localStorage.getItem('userRegion');
    if (!userRegionData) {
      console.log('No user region data found in localStorage');
      return null;
    }
    
    const userRegion = JSON.parse(userRegionData);
    console.log('User region data:', userRegion);
    
    // Fetch subscription plans from API using request function
    console.log('Fetching subscription plans...');
    const response = await request({
      url: `/payment-subscription/get-all-subscriptions`,
      method: "POST",
      data: {},
    });
    
    console.log('Raw API response:', response);
    
    // Decode the data using your existing logic
    const decodeData = decodedData(response, "plan_subscription_key");
    console.log('Decoded data:', decodeData);
    
    const subsProducts = decodeData?.data;
    
    if (!subsProducts || !Array.isArray(subsProducts)) {
      console.log('No subscription products found');
      return null;
    }
    
    console.log('Decoded subscription products:', subsProducts);
    
    // Find BASIC plan with monthly interval
    const basicPlan = subsProducts.find(plan => 
      plan.name?.toLowerCase().includes('basic') && 
      plan.interval === 'monthly'
    );
    
    if (!basicPlan) {
      console.log('Basic monthly plan not found');
      return null;
    }
    
    console.log('Basic monthly plan found:', basicPlan);
    
    // Find price for user's region
    const userCountry = userRegion.country;
    const userCurrency = userRegion.currency;
    
    console.log('Looking for price for country:', userCountry, 'currency:', userCurrency);
    
    // Find price that matches user's region or currency
    const priceObj = basicPlan.prices.find(price => 
        price.region === userCountry && price.currency === userCurrency
    ) || basicPlan.prices.find(price => price.region === 'US'); // fallback to USD price
    
    // divide PK price by 100 if user currency is PKR This is some stripe Condition
    if(userCurrency === 'PKR') {
      priceObj.amount = priceObj.amount / 100;
    }

    if (!priceObj) {    
      console.log('No price found for user region');
      return null;
    }
    
    console.log('Price object found:', priceObj);
    
    return {amount: priceObj.amount, currency: priceObj.currency}
    
  } catch (error) {
    console.error('Error getting Basic plan price:', error);
    return null;
  }
}


export default getBasicPlanPrice;
